import React, { PureComponent } from "react";
import moment from "moment";

import { AppContext } from "../contexts/AppContextProvider";
import { withRouter } from "react-router-dom";

import WidgetContainer from "./WidgetContainer";
import { component } from "./component";

import * as Sentry from "@sentry/react";
import { allowedWidgetWithoutURL } from "./Utils/Constants";

class Page extends PureComponent {
  static contextType = AppContext;

  renderRow = (o, key, project, page, current_project_id) => {
    let url = o.props.url ? o.props.url : "";

    const { pageSettings } = this.props.pageSettings.state;

    // Tenant specific insights config/parameters
    const insightsProps = this.props.projectSettings.projectObj.insightsConfig;
    const widgetProps = {
      widget: o.widget,
      url: url,
      project: project,
      project_id: current_project_id,
      insightsConfig: insightsProps,
      insights: o.props.insights,
      size: o.props.size,
      title: o.props.title,
      description: o.props.description,
      tooltip: o.props.tooltip,
      goal: o.props.goal,
      cells: o.props.cells,
      chart: o.props.chart,
      table_filter: o.props.table_filter,
      columns: o.props.columns,
      metrics: o.props.metrics,
      funnels: o.props.funnels,
      csv_export: o.props.csv_export,
      pagination: o.props.pagination,
      footer: o.props.footer,
      first_tick: o.props.first_tick,
      group_slug: pageSettings.group_slug,
      group_name: pageSettings.group_name,
      boardFilters: pageSettings.boardFilters,
      filter_id: pageSettings.filter_id,
      region_slug: pageSettings.region_slug,
      start_date: pageSettings.start_date,
      end_date: pageSettings.end_date,
      pageContainerGlobalDateChange: this.pageContainerGlobalDateChange,
      test_selector: `test-${o.widget.toLowerCase()}-${key}`,
      filterDimensions:
        this.context.state.currentProject.boardObj.filterDimensions,
      maintenance: o.props.maintenance,
    };

    const options = {
      has_datepicker: o.options && o.options.includes("datetime"),
      has_groups: o.options && o.options.includes("groups"),
      has_regions: o.options && o.options.includes("regions"),
      has_filter: o.options && o.options.includes("filter"),
    };

    const props = Object.assign({}, widgetProps, options, this.state);

    // Don't place presentational widgets inside WidgetContainer && allow to display widgets that doesn't contain the URL but contains title
    if (url || allowedWidgetWithoutURL.includes(props.widget)) {
      return <WidgetContainer {...props} key={o.props.url + key} />;
    } else {
      let Component = component(o.widget);
      return <Component {...props} key={o.props.url + key} />;
    }
  };

  trackPageView = () => {
    const project = this.context.state.currentProject.projectObj;
    const board = this.context.state.currentProject.boardObj;

    window.analytics.page(board.title, {
      project_name: project.title,
      project_id: project.id,

      board_name: board.title,
      board_id: board.id,
    });
  };

  componentDidMount() {
    this.trackPageView();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.trackPageView();
    }
  }

  pageContainerGlobalDateChange = (start, end) => {
    const { currentProject } = this.context.state;

    const start_date =
      start === undefined ? start : moment(start).format("YYYY-MM-DD");
    const end_date = end === undefined ? end : moment(end).format("YYYY-MM-DD");

    this.props.pageSettings.dispatch({
      type: "PAGE-SET-SETTINGS",
      payload: {
        start_date: start_date,
        end_date: end_date,
        ...(start === end && end === undefined ? { boardFilters: [] } : null),
      },
    });

    window.analytics.track("Widget Date Change (Global)", {
      type: "Global Custom Date Change",
      start_date: start_date,
      end_date: end_date,
      board: currentProject.board,
      project: currentProject.project,
      page: currentProject.page,
    });
  };

  renderPage = () => {
    const { project, page, data } = this.context.state.currentProject;
    const current_project = data.projects.find((p) => p.slug === project);
    const current_project_id = current_project.id;

    let current_page_rows = [];

    if (page) {
      if (
        current_project.boards.find((b) => b.slug === page).configs.length > 0
      ) {
        current_page_rows = current_project.boards.find((b) => b.slug === page)
          .configs[0].contents;
      } else {
        current_page_rows = [];
      }
    } else {
      current_page_rows = current_project.boards[0].configs[0].contents;
    }

    if (current_page_rows.length > 0) {
      return current_page_rows.map((row, key) => {
        const style =
          row.widget === "PageDivider" ? "row" : "row border-between";

        return (
          <div className={style} key={key}>
            {row.map((widget, key) =>
              this.renderRow(widget, key, project, page, current_project_id)
            )}
          </div>
        );
      });
    } else {
      return (
        <div id="qa-missing-config" className="mt-5">
          <h4>
            There is no{" "}
            {window.localStorage.configVersion ? (
              <mark>{window.localStorage.configVersion}</mark>
            ) : null}{" "}
            configuration for this board.
          </h4>
        </div>
      );
    }
  };

  render = () => {
    const { project } = this.context.state.currentProject;
    return (
      <Sentry.ErrorBoundary>
        {project === "britbox" && (
          <div
            className="alert alert-warning mr-2 ml-2 mt-4 rounded"
            role="alert"
          >
            <small>
              Evergent billing metrics are still pending confirmations with
              Evergent.
            </small>
          </div>
        )}
        {project === "sky-revenue" && (
          <div className="disclaimer-note pt-3 ">
            Please note: Youtube provides data from 2 days ago.
          </div>
        )}

        {project === "nexstar" && (
          <div
            className="alert alert-warning mr-2 ml-2 mt-4 rounded"
            role="alert"
          >
            <small>
              Please Note: The data displayed below does not include data from
              GAM meaning that Direct Revenue and Direct CPM are not
              represented. The Ad Board includes data from all stations, however
              the Video Board is inclusive of the stations with Segment
              implemented noted <a href="/nexstar/query#xBcQU9cW">here</a>.
            </small>
          </div>
        )}

        {this.renderPage()}
      </Sentry.ErrorBoundary>
    );
  };
}

export default withRouter((props) => <Page {...props} />);
